import './GfLoader.scss';

import React from 'react';
import classNames from 'classnames';
import { GfComponentProps } from 'gf-types';

type GfLoaderProps = GfComponentProps<{
  /**
   * The text to show in the loading spinner
   * NOTE: text takes precedence over children, so if both are provided, only text will be displayed.
   */
  text?: string;
  /** Whether to show the loader inline */
  inline?: boolean;
  /** The size of the loading spinner */
  size?: 'tiny' | 'small' | 'medium' | 'large';
}>;

/** A loading spinner. */
export default function GfLoader({ children, className, text, inline, size }: GfLoaderProps) {
  if (inline) {
    return (
      <div className={classNames(className, 'gf-loader ui active centered inline loader', size)} role="status">
        <span className="loader-content">{text ?? children}</span>
      </div>
    );
  }

  return (
    <div className={classNames(className, 'gf-loader ui active inverted dimmer')} role="status">
      <div className={classNames('ui loader', size)}>
        <div className="loader-content">{text ?? children}</div>
      </div>
    </div>
  );
}
